module.exports = __webpack_public_path__ + "static/media/recipes-title.1f6b7092.svg";